<template>
    <div class="container">
        <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white">Subscribe for newsletter</h2>
        <div class="row justify-content-center align-self-center">
            <form v-on:submit.prevent="onSubmit" class="col-md-6">
                <div class="row">
                    <div class="col form-group">
                        <i class="material-icons material-icons-footer">mail_outline</i>
                        <input v-model="email" required type="email" class="form-control input-style rounded-0 border-top-0 border-right-0 border-left-0 white" aria-describedby="emailHelp" placeholder="Enter your email">
                    </div>
                </div>
                <button type="submit" class="inside-submit">
                    <i v-if="!loading" class="material-icons white">arrow_forward</i>
                    <div v-if="loading" class="loader">
                        <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                </button>
            </form>
        </div>
    </div>

</template>

<script>

    export default {
        props: {
            loading: {
                required: true,
                type: Boolean,
            }
        },
        data() {

            return {
                email: ''
            };
        },

        methods: {
            onSubmit() {
                this.$emit('submit', {email: this.email});
            }
        }
    };

</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>